<template>
  <v-container>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        v-show="showDialog"
        @click:outside="closeDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-form ref="form" lazy-validation @input="formToggled">
            <v-card-title class="subtitle-1 grey accent" primary-title>
              <span v-if="!isUpdate" class="text-h5"
                >Add WholeSale Language</span
              >
              <span v-if="isUpdate" class="text-h5"
                >Update WholeSale Language</span
              >
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <v-text-field
                      color="accent"
                      label="Name"
                      v-model="currentBrand.name"
                      type="text"
                      outlined
                      dense
                      clearable
                      :rules="[rules.required]"
                      @wheel="$event.target.blur()"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="accent"
                      label="code"
                      v-model="currentBrand.code"
                      type="text"
                      outlined
                      dense
                      clearable
                      :rules="[rules.required]"
                      @wheel="$event.target.blur()"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Translation of the key Words</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-row v-for="(item, i) in keyWords" :key="i">
                          <v-col>
                            <v-text-field
                              color="accent"
                              :label="item.text"
                              v-model="currentBrand[item.value]"
                              type="text"
                              outlined
                              dense
                              clearable
                              :rules="[rules.required]"
                              @wheel="$event.target.blur()"
                            >
                            </v-text-field
                          ></v-col>
                        </v-row> </v-expansion-panel-content></v-expansion-panel
                  ></v-expansion-panels>
                </v-row>
                <v-row>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Translation of the description
                        keyWords</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-row>
                          <v-alert color="#BBDEFB"
                            ><h6>
                              Please when you create the translation keep the
                              "[VALUE]" as it should be to replace with the real
                              value in the description
                            </h6></v-alert
                          >
                        </v-row>
                        <v-row v-for="(item, i) in keWordsWithValue" :key="i">
                          <v-col>
                            <v-text-field
                              color="accent"
                              :label="item.text"
                              v-model="currentBrand[item.value]"
                              type="text"
                              outlined
                              dense
                              clearable
                              :rules="[rules.required]"
                              @wheel="$event.target.blur()"
                            >
                            </v-text-field
                          ></v-col>
                        </v-row> </v-expansion-panel-content></v-expansion-panel
                  ></v-expansion-panels>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialog">
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                v-if="!isUpdate"
                text
                @click="CreateBrand"
              >
                Save
              </v-btn>
              <v-btn
                color="blue darken-1"
                v-if="isUpdate"
                text
                @click="CreateBrand"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatusDialog"
        @showProductInfo="postSearch(product.SKU)"
        :textColor="textColor"
        :showCheckBtn="showCheckBtn"
      ></status-info>
    </v-dialog>
    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import StatusInfo from "../organisms/StatusInfo";

export default {
  name: "create-wh-Language",
  props: {
    Brand: Object,
    close: Function,
    isUpdate: Boolean,
    DoesCreated: Function,
  },
  components: {
    StatusInfo,
  },
  data: () => ({
    keyWords: [
      {
        value: "mix",
        text: "mix",
      },
      {
        value: "item",
        text: "item",
      },
      {
        value: "size line",
        text: "size line",
      },
      {
        value: "pricePerKg",
        text: "price per kilogramme",
      },
      {
        value: "pricePerPiece",
        text: "price per piece",
      },
      {
        value: "pcs",
        text: "pieces",
      },
      {
        value: "kgs",
        text: "kgs",
      },

      {
        value: "Brand",
        text: "brand",
      },
      {
        value: "season",
        text: "Season",
      },
      {
        value: "minOrder",
        text: "Minimum order",
      },
      {
        value: "WHCR",
        text: "WH CR",
      },
    ],
    keWordsWithValue: [
      {
        value: "vers1",
        text: "Packed by [VALUE] in package",
      },
      {
        value: "vers2",
        text: "Estimate weight [VALUE] KG per package",
      },
      {
        value: "vers3",
        text: "Estimate packing information",
      },
      {
        value: "vers4",
        text: "with small small defects",
      },
    ],
    dialog: true,
    showDialog: true,
    statusDialog: false,
    pending: false,
    filename: "",
    showCheckBtn: false,
    textColor: "",
    responseMessage: "",
    currentBrand: {},
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    snackbarText: "",
    snackbar: false,
    ForUpdate: false,
  }),
  mounted() {
    console.log(this.isUpdate);
    console.log(this.Brand);
    this.ForUpdate = this.isUpdate;
    console.log(this.isUpdate);
    console.log(this.ForUpdate);
    if (this.isUpdate) {
      this.currentBrand = this.Brand;
    }
    if (!this.Brand) {
      this.ForUpdate = false;
    }
  },

  methods: {
    closeDialog() {
      this.close();
      this.dialog = false;
      this.ForUpdate = false;
    },
    closeStatusDialog() {
      this.close();
      this.dialog = false;
      this.statusDialog = false;
      this.showDialog = false;
      this.ForUpdate = false;
    },
    formToggled() {},
    async CreateBrand() {
      if (this.$refs.form.validate()) {
        //show pending dialog
        this.pending = true;
        this.statusDialog = true;
        this.textColor = "basic--text";
        //stop showing product form dialog
        this.dialog = false;
        // TODO create the function that will call the API !
        if (!this.isUpdate) {
          this.$store
            .dispatch("createWHLanguage", this.currentBrand)
            .then(() => {
              this.pending = false;
              this.statusDialog = true;
              this.responseMessage = "Language created ! ";
              this.filename = "high_five.svg";
              this.DoesCreated();
            })
            .catch((error) => {
              console.log(error);
              this.pending = false;
              this.statusDialog = true;
              this.filename = "server_down.svg";
              this.responseMessage = "Something went wrong! Please try again!";
            });
        } else {
          this.$store
            .dispatch("updateWHLanguage", this.currentBrand)
            .then(() => {
              this.pending = false;
              this.statusDialog = true;
              this.responseMessage = "Language updated ! ";
              this.filename = "high_five.svg";
              this.DoesCreated();
            })
            .catch((error) => {
              console.log(error);
              this.pending = false;
              this.statusDialog = true;
              this.filename = "server_down.svg";
              this.responseMessage = "Something went wrong! Please try again!";
            });
        }
      } else {
        this.snackbarText = "The form is filled incorretly!";
        this.snackbar = true;
      }
    },
  },
};
</script>

<style>
.add_wh_pr_modal {
  background-color: #fff !important;
}
div#text {
  margin-top: 48px;
  text-align: center;
}
div#dropzone {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: visibility 175ms, opacity 175ms;
  display: table;
  text-shadow: 1px 1px 2px #000;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  font: bold 42px Oswald, DejaVu Sans, Tahoma, sans-serif;
}
div#textnode {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  transition: font-size 175ms;
}
</style>
